<template>

<core-modal v-on:close="onClose" :is-empty="!items.length" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		{{ family.name }}

	</template>

	<template v-slot:default>

        <div class="manage-empty" v-if="!items.length">

            No tags added to family.

        </div>

		<template v-for="item in items">

			<com-tag :key="item.id" :tag="item" v-if="item.isTag" />

		</template>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onCreateTagClick">Create Tag</core-button>

		<core-button theme="blue" v-on:click.native="onEditFamilyClick">Edit Family</core-button>

	</template>

</core-modal>

</template>

<script>

import comTag from './../manage/Tag'

export default {

	props: ['data'],

	components: {
		'com-tag': comTag
	},
	
	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

        family: function() {

            return this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.data.family

            }.bind(this))

        },

		items: function() {

			var items = []

			this.$_.each(this.tags, function(tag) {

				tag = this.$util.copy(tag)
				tag.sort = tag.text
				tag.isTag = true

				items.push(tag)

			}.bind(this))

			items = this.$_.sortBy(items, function(item) {

				return item.sort.toLowerCase()

			})

			return items

		},

		tags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

                return tag.family === this.data.family

            }.bind(this))

		}

	},

	methods: {

        onCreateTagClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagCreate',
				family: this.data.family
			})	

        },

        onEditFamilyClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagFamilyEdit',
				family: this.data.family
			})	

        },

		onClose: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagManage'
			})	

		}

	}

}

</script>

<style scoped>

.manage-empty {
    position: absolute;
    left: 0%;
    top: 50%;
    width: 100%;
    font-size: 20px;
    color: #fff;
    opacity: 0.75;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    padding: 16px;
}

</style>